module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970-desktop/0068.jpg?v=1694bb02";